import React from "react";
import { Box } from "@mui/material";

export default function MainContent({ user, children }) {
  return (
    <Box className="inner-content" >
      {/* Optional heading or user info */}

      {/* Render nested content */}
      {children}
    </Box>
  );
}
